import type { UseQueryResult } from '@tanstack/react-query';
import { skipToken, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export const familiesRegenerationResultSchema = z.array(
    z.object({
        createdAt: z.string(),
        jobArchitectureId: z.string(),
        regenerationId: z.string(),
    }),
);

export type FamiliesRegenerationResult = z.infer<typeof familiesRegenerationResultSchema>;

export const useFamiliesRegenerationResults = (
    jobArchitectureId: string | undefined,
): UseQueryResult<FamiliesRegenerationResult, Error> => {
    const { fetchFamiliesRegenerationResults } = useApplicationFetchers();

    return useQuery({
        queryKey: jobArchitectureKeys.familiesRegenerationResults(jobArchitectureId),
        queryFn:
            jobArchitectureId === undefined
                ? skipToken
                : async () => {
                      const result = await fetchFamiliesRegenerationResults({ jobArchitectureId });

                      if (result.isOk) {
                          return result.value;
                      }

                      throw result.error;
                  },
        throwOnError: false,
    });
};
